import React from "react";
import { Route, Routes } from "react-router-dom";
import MainCodePage from "./MainCodePage";
import ProtectedRoute from "../../ProtectedRoute";
import EditCodePage from "./EditCodePage";
import PageNotFound from "../PageNotFound";

const CodeRouter: React.FC = () => {
  return (
    <Routes>
      <Route
        index
        element={<ProtectedRoute element={<MainCodePage />} />}
      />
      <Route
        path=":_id/edit"
        element={<ProtectedRoute element={<EditCodePage />} />}
      />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default CodeRouter;
